import { render, staticRenderFns } from "./serveNews.vue?vue&type=template&id=7ed9f014&scoped=true&"
import script from "./serveNews.vue?vue&type=script&lang=js&"
export * from "./serveNews.vue?vue&type=script&lang=js&"
import style0 from "./serveNews.vue?vue&type=style&index=0&id=7ed9f014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed9f014",
  null
  
)

export default component.exports